import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../Button/Button";
// import { Checkbox, FormControlLabel } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
// import TelInputController from "../../../Input/TelInputField/TelInputController"; // Import your TelInputController
import { signUpUpdateStyles as styles } from "./signUpUpdate.tailwind";
import Checkbox from '../../../Input/Checkbox/Checkbox';
import { connect, useSelector } from "react-redux";
import { signUpUpdatesSchema, otpValidationSchema } from "./signUpUpdate.validation";
import { yupResolver } from "@hookform/resolvers/yup";
import InputController from "../../../Input/InputField/InputController";
import { optInForUpdates, resendUpdateVerificationCode } from "../../../../../redux/slices/rewardSlice";
import { Edit } from "@mui/icons-material";
import { RESEND_OTP_DURATION } from "../../../../../lib/constants/globalConstant";
import { getUserDetails } from "../../../../../redux/slices/userSlice";
import notify from '../../../../../assets/svgs/notify.svg';

const SignUpUpdatesModal = ({ isOpen, onClose, optIn, resendOTP, getUser }) => {
  const { user } = useSelector((state) => state.user);
  const userEmail = user?.userDetails?.userEmail;
  // console.log('userEmail: ',userEmail);
  const resendOtpDuration = RESEND_OTP_DURATION;

  const { isOptingInForUpdates, isResendingVerificationCode } = useSelector((state) => state.reward);

  const [otpReceived, setOtpReceived] = useState(false);
  const [countdown, setCountdown] = useState(resendOtpDuration);
  const [timerActive, setTimerActive] = useState(false);

  const { control, handleSubmit, getValues, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(otpReceived ? otpValidationSchema : signUpUpdatesSchema)
  });

  // const values = getValues();
  // const isChecked = getValues().receiveUpdates;
  const isChecked = useWatch({ control, name: "receiveUpdates" }) || "";

  // MAKE THE API CALL TO RESEND THE OTP
  const handleResendOTP = async () => {
    const values = getValues();

    const { email: enteredEmail } = values;

    const data = {
      email: enteredEmail
    }

    const _response = await resendOTP(data);
    if (resendUpdateVerificationCode.fulfilled.match(_response)) {
      setOtpReceived(true);
      setCountdown(resendOtpDuration);
      setTimerActive(true);
      // setValue('newEmail', enteredEmail);
    }
  }

  const onSubmit = async () => {
    // onClose();
    // Handle the logic after form submission (API call)
    const values = getValues();

    const { email: enteredEmail, otp: enteredOTP } = values;

    const data = {
      email: enteredEmail,
      otp: otpReceived ? enteredOTP : '',
    }

    // MAKE THE API CALL THERE CHECK IF STATUS IS 1 THEN FINE ELSE IF STATUS IS 2 THEN NEED TO SHOW THE OTP FIELD AND MAKE THE API CALL AGAIN (REST CHECKS ARE DONE IN BACKEND)
    const _response = await optIn(data);

    if (optInForUpdates.fulfilled.match(_response)) {
      const _resp = _response.payload;
      // console.log(_resp)

      if (_resp?.status === 1) {
        handleClose();
        getUser()
      } else if (_resp?.status === 2) {
        setOtpReceived(true);
        setCountdown(resendOtpDuration);
        setTimerActive(true);
        setValue('newEmail', enteredEmail);
      }
      return;
    }

    return;
  };

  // handle otp to just enter the digits and not let the user enter more than 6
  const handleOtpChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, '');
    if (value.length > 6) {
      value = value.slice(0, 6);
    }
    setValue("otp", value);
  };

  const handleEditEmail = () =>{
    setOtpReceived(false);
    setValue('otp','');
  }

  const resetStates = () => {
    setOtpReceived(false);
    setCountdown(resendOtpDuration);
    setTimerActive(false);
    setValue('email',userEmail);
    setValue('newEmail','');
    setValue('otp','');
    setValue('receiveUpdates',false);
  }

  const handleClose = () => {
    resetStates();
    onClose();
  }

  // Timer for resend otp
  useEffect(() => {
    if (otpReceived && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (countdown === 0) {
      setTimerActive(false);
    }
  }, [otpReceived, countdown]);

  useEffect(() => {
    if (userEmail?.trim() !== "") {
      setValue("email", userEmail)
    }
  }, []);

  return (
    <Modal open={isOpen} onClose={handleClose} disableAutoFocus>
      <div className={styles.container}>
        {/* Close button aligned to the right */}
        <button onClick={handleClose} className={styles.closeButton}>
          <CloseIcon sx={{ position: 'absolute', top: 0, right: 0, cursor: 'pointer', fontSize: '13px' }} />
        </button>
        <div className={styles.dataContainer}>
          <div className={styles.popupheading}>
          <img src={notify} alt="notify" className={styles.notify}></img>
          <span className={styles.heading}>Sign Up for Updates!</span>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className={styles.formContainer}>
            <div className={styles.inputContainer}>
              {!otpReceived ? (
                <InputController
                  label="Email"
                  name="email"
                  type="text"
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                  control={control}
                />
              ) : (
                <>
                  <div className="flex w-full justify-end mt-1">
                    <button className={styles.edit_email} type="button" onClick={handleEditEmail}>
                      <Edit fontSize="10" />
                      Edit Email
                    </button>
                  </div>

                  <InputController
                    label="Email"
                    name="newEmail"
                    type="text"
                    disabled={true}
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                    control={control}
                  />
                </>
              )}

              {otpReceived && (
                <div className={styles.afterOtpreceivedContainer}>
                  {/* Common spam folder reminder */}
                  <div className={styles.spamNote}>
                    OTP sent. Look in inbox or spam.
                  </div>

                  {/* Dynamic resend content */}
                  {timerActive ? (
                    <div className={styles.resendOtp}>
                      Resend OTP in {countdown}s
                    </div>
                  ) : (
                    countdown === 0 && (
                      <button
                        className={`${styles.resendOtp}`}
                        // disabled={changing}
                        type="button"
                        onClick={handleResendOTP}
                      >
                        {/* {changing ? "Resending OTP..." : "Resend OTP"} */}
                        {/* TAKE REFERENCE OF CHANGING FROM THE USERUPDATE EMAIL COMPONENT */}
                        resend OTP
                      </button>
                    )
                  )}
                </div>
              )}
            </div>

            {otpReceived && (
              <div className={styles.otpContainer}>
                <InputController
                  control={control}
                  showLabel={true}
                  name="otp"
                  label="Enter OTP"
                  type="number"
                  onChange={handleOtpChange}
                  error={!!errors?.otp} // Pass error state
                  helperText={errors?.otp?.message} // Pass error message
                />
              </div>
            )}

            <Checkbox
              name="receiveUpdates"
              control={control}
              label={<span className={styles.checklabel}>Check here to receive notifications about new rewards.</span>}
              className='!text-[15px]'
            />

            {/* Done Buton */}
            <Button variant="theme" className="w-full mt-[10px] text-[13px]" disabled={!isChecked || isOptingInForUpdates || isResendingVerificationCode}>
              {isOptingInForUpdates ? `Signing Up...` : `Done`}
            </Button>
          </form>
        </div>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  optIn: (data) => dispatch(optInForUpdates(data)),
  resendOTP: (data) => dispatch(resendUpdateVerificationCode(data)),
  getUser: () => dispatch(getUserDetails()),
})

export default connect(null, mapDispatchToProps)(SignUpUpdatesModal);
